import React from "react";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import TableBody from "@mui/material/TableBody";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import {v4} from "uuid";
import TableContainer from "@mui/material/TableContainer";
import {IResult} from "../_interfaces/IResult";
import {s_results} from "../_signals/s_results";
import {useSignals} from "@preact/signals-react/runtime";
import {ResultsClear} from "../_api/BEResult";
import {s_app_rid, s_app_sl} from "../_signals/s_app";

function RolledList() {
    useSignals()
    const rolledListRow = (result: IResult) => {
        const sl = s_app_sl.value;

        if (!sl && result.sl) return null;
        const date = new Date(result.time);
        let options: Intl.DateTimeFormatOptions = {
            hour12: false,
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit"
        };

        const time = date.toLocaleTimeString('de-DE', options);

        return <TableRow key={v4()}>
            <TableCell>{time}</TableCell>
            <TableCell>{result.name}{result.nsc && sl ? <AutoAwesomeIcon/> : ''}</TableCell>
            <TableCell>
                {result.title}
                {result.eff ? <div style={{fontSize: 'smaller'}}>{result.eff}</div> : null}
                {result.addEff ? <div style={{fontSize: 'smaller'}}>{result.addEff}</div> : null}
            </TableCell>
            <TableCell style={{textAlign: 'left'}}>
                {result.rollas === 'ini' ? 'Intiative' : null}
                {result.rollas === 'ep' ? 'Erholungsprobe' : null}
                {result.rollas === 'nsp' ? 'Niederschlagsprobe' : null}
                {result.rollas === 'hit' ? 'Trefferwurf' : null}
                {result.rollas === 'dmg' ? 'Schadenswurf' : null}
            </TableCell>
            <TableCell style={{textAlign: 'center'}}>{result.result}</TableCell>
        </TableRow>
    }


    return <Paper className={'rolledList'} style={{overflowX: 'auto', marginTop: 24}}>
        <h3 style={{margin: 6}}>Ergebnisse {s_app_sl.value ?
            <Button className={'btn'} id="clearList"
                    onClick={() => ResultsClear(s_app_rid.value)}>X</Button> : ''}</h3>
        <TableContainer style={{margin:6, maxHeight: 100}}>
            <Table stickyHeader style={{width: '100%'}}>
                <TableHead>
                    <TableRow>
                        <TableCell style={{textAlign: 'left'}}>Wann</TableCell>
                        <TableCell style={{textAlign: 'left'}}>Wer</TableCell>
                        <TableCell style={{textAlign: 'left'}}>Was</TableCell>
                        <TableCell style={{textAlign: 'left'}}>Als</TableCell>
                        <TableCell style={{textAlign: 'center'}}>Ergebnis</TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    {s_results.value.map((row) => rolledListRow(row))}
                </TableBody>

            </Table>
        </TableContainer>
    </Paper>

}

export default RolledList